import { ARRIVE_SERVICE_FAILED, ARRIVE_SERVICE_SUCCESS, ARRIVE_SERVICE_LOADING, ARRIVE_SERVICE_RESET } from "../types"

const initialState = {
  loading: false,
  error: false,
  message: null,
  success: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ARRIVE_SERVICE_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        message: null,
        success: false,
      }
    case ARRIVE_SERVICE_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        success: false,
      }
    case ARRIVE_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: null,
        success: true,
      }
    case ARRIVE_SERVICE_RESET:
      return {
        ...state,
        loading: false,
        error: false,
        message: null,
        success: false
      }
    default:
      return state
  }
}
